import styled from '@emotion/styled';
export const LogoImage = styled('img')(() => ({
  maxWidth: 200,
  maxHeight: 22,
  height: 'auto',
}));
